import styled from 'styled-components';

export const CarrouselContainer = styled.div`
    .slick-slider {
        height: 100%;
    }
    .item {
        position: relative;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .fleche {
        width: 20px;
        height: 40px;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        cursor: pointer;
        z-index: 1;

        &.fleche-g {
            left: -20px;
        }

        &.fleche-d {
            right: -20px;
        }

        svg path {
            fill: ${props => props.theme.lightGrey};
        }

        .isvg {
            line-height: 0.7;
        }
    }
    @media screen and (max-width: ${props => props.theme.mobile}) {
        .fleche.fleche-g {
            left: 5px;
        }
        .fleche.fleche-d {
            right: 5px;
        }
        .fleche svg.svg {
            width: 9px;
            height: 16px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/carousel/CarouselComponentStyle.js